/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PatchApiGreetingsStatusMutationRequest, PatchApiGreetingsStatusMutationResponse, PatchApiGreetingsStatus400, PatchApiGreetingsStatus401, PatchApiGreetingsStatus403, PatchApiGreetingsStatus404, PatchApiGreetingsStatus500 } from "../../types/PatchApiGreetingsStatus.ts";
import { patchApiGreetingsStatusMutationResponseSchema, patchApiGreetingsStatusMutationRequestSchema } from "../../zod/GreetingsSchemas/patchApiGreetingsStatusSchema.ts";

function getPatchApiGreetingsStatusUrl() {
  const res = { method: 'PATCH', url: `/api/greetings/status` as const }  
  return res
}

/**
 * @summary Изменение статуса шаблона
 * {@link /api/greetings/status}
 */
export async function patchApiGreetingsStatus({ data }: { data?: PatchApiGreetingsStatusMutationRequest }, config: Partial<RequestConfig<PatchApiGreetingsStatusMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = patchApiGreetingsStatusMutationRequestSchema.parse(data)  
  
  const res = await request<PatchApiGreetingsStatusMutationResponse, ResponseErrorConfig<PatchApiGreetingsStatus400 | PatchApiGreetingsStatus401 | PatchApiGreetingsStatus403 | PatchApiGreetingsStatus404 | PatchApiGreetingsStatus500>, PatchApiGreetingsStatusMutationRequest>({ method : "PATCH", url : getPatchApiGreetingsStatusUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return patchApiGreetingsStatusMutationResponseSchema.parse(res.data)
}